<template>
  <!-- アポイントメント一覧検索 -->
  <div id="AppAppointmentSearchResult">
    <!-- 検索結果 -->
    <section>
      <div class="box" style="resultArea;" v-show="hasResult">
        <div class="columns">
          <div class="column is-two-thirds" style="text-align:left;">
            <b-button
              class="button is-primary has-text-centered"
              icon-left="google-maps"
              :disabled="!checkedRows.length"
              native-type="button"
              position="is-right"
              v-on:click="doShowGoogleMapChecked"
            >地図表示</b-button>
          </div>
          <div class="column">
            <b-field horizontal label="検索結果" style="float:right; white-space:nowrap;">
              <b-select position="is-right" v-model="perPage">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div>
          <b-table
            :data="data"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :pagination-size="paginationSize"
            :default-sort-direction="defaultSortDirection"
            default-sort="scheduledDay"
            detailed
            detail-key="reservationId"
            checkable
            :checked-rows.sync="checkedRows"
            checkbox-position="left"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column
                field="reservationId"
                label="予約番号"
                sortable
                centered
              >{{ props.row.reservationId }}</b-table-column>
              <b-table-column
                field="scheduledDay"
                label="点検予定日"
                sortable
                centered
              >{{ props.row.scheduledDay }}</b-table-column>
              <b-table-column
                field="scheduledTime"
                label="点検予定時刻"
                sortable
                centered
              >{{ props.row.scheduledTime }}</b-table-column>
              <b-table-column
                field="crossBorderCofficeSrc"
                label="越境依頼元"
                sortable
                centered
              >{{ props.row.crossBorderCofficeSrc }}</b-table-column>
              <b-table-column
                field="crossBorderCofficeTar"
                label="越境依頼先"
                sortable
                centered
              >{{ props.row.crossBorderCofficeTar }}</b-table-column>
              <b-table-column
                field="patientName"
                label="患者名"
                sortable
                centered
              >{{ props.row.patientName }}</b-table-column>
              <b-table-column
                field="patientZipCode"
                label="郵便番号"
                sortable
                centered
              >{{props.row.patientZipCode}}</b-table-column>
              <b-table-column
                field="staffName"
                label="点検担当者"
                sortable
                centered
              >{{ props.row.staffName }}</b-table-column>
              <b-table-column field="status" label="実施状況" sortable centered>
                <span
                  :class="['tag',
                       {'is-success':props.row.status == 6},
                       {'is-danger':props.row.status == 1},
                       {'is-warning':props.row.status == 2},
                       {'is-warning':props.row.status == 3},
                       {'is-warning':props.row.status == 4},
                       {'is-dark':props.row.status == 5}
                       ]"
                >{{ props.row.status | inspectionStatusFillter}}</span>
              </b-table-column>
              <b-table-column field="configuration" label="編集" centered>
                <b-button
                  v-if="props.row.status==6 | props.row.status==5 | editFlg"
                  class="button is-primary has-text-centered"
                  icon-left="checkbox-multiple-blank-outline"
                  native-type="button"
                  v-on:click="edit(props.row.reservationId, props.row.status,props.row.crossBorderCofficeTarCode,true,props.row)"
                ></b-button>
                <b-button
                  v-else
                  class="button is-primary has-text-centered"
                  icon-left="mdi mdi-cog"
                  native-type="button"
                  v-on:click="edit(props.row.reservationId, props.row.status,props.row.crossBorderCofficeTarCode,false,props.row)"
                ></b-button>
              </b-table-column>
            </template>
            <template slot="detail" slot-scope="props">
              <div v-if="!props.row.patients.length" class="content">
                <table style="table-layout: fixed;">
                  <tr>
                    <th style="width:20%;">点検実施住所：</th>
                    <td style="width:80%;">
                      {{ props.row.inspectionAddress }}
                      <b-field class="file" style="float:right">
                        <b-button
                          class="button is-primary has-text-centered"
                          icon-left="google-maps"
                          native-type="button"
                          v-on:click="doShowGoogleMap([
                                {
                                    'address': props.row.inspectionAddress,
                                    'name': props.row.patientName
                                }
                                ])"
                        ></b-button>
                      </b-field>
                    </td>
                  </tr>
                  <tr>
                    <th>連絡先：</th>
                    <td colspan="2">{{ props.row.patientPhone }}</td>
                  </tr>
                  <tr>
                    <th>点検対象機種：</th>
                    <td>
                      <table style="padding: 0px;">
                        <template v-for="product in props.row.productList">
                          <tr v-bind:key="product.productCode" v-if="product.inspectionKind===true">
                            <td style="width:250px;padding: 0px;">{{ product.productName }}</td>
                            <td style="width:300px;padding: 0px;">(器械交換：{{ product.machineReplace }} , 点検指示内容：{{ product.inspectionOrder | inspectionOrderFilter }} )</td>
                            <td style="padding: 0px;"></td>
                          </tr>
                        </template>
                      </table>
                    </td>
                    <td>
                      <b-button
                        v-if="props.row.status < 5"
                        :disabled="editFlg"
                        style="float:right; bottom:0;"
                        class="button is-primary has-text-centered"
                        icon-left="checkbox-multiple-marked-outline"
                        native-type="button"
                        v-on:click="startInspection(props.row.reservationId,props.row.staffCode,props.row.staffName,props.row.patientName,props.row.patientCode,props.row.crossBorderCofficeSrc,props.row.crossBorderCofficeSrcCode, props.row.inspectionType, props.row.status, props.row)"
                      >点検開始</b-button>
                    </td>
                  </tr>
                </table>
              </div>

              <div v-else class="content">
                <b-button
                  v-if="props.row.status != 6"
                  :disabled="disabledCompleteBulkInspaction(props.row)"
                  style="float:right; bottom:0; margin-bottom: 1rem"
                  class="button is-primary has-text-centered"
                  icon-left="folder-upload"
                  native-type="button"
                  v-on:click="inputSign()"
                >一括点検完了</b-button>
                <b-modal :active.sync="isSign" has-modal-card full-screen>
                  <sign-modal
                    ref="signModal"
                    v-model="isSign"
                    @signed="completeBulkInspaction($event, props.row)"
                  ></sign-modal>
                </b-modal>

                <table v-for="(patient, index) in props.row.patients" :key="'patient' + index" style="table-layout: fixed;">
                  <tr style="border-top: 1px solid #dbdbdb">
                    <th style="width:20%;">患者名：</th>
                    <td style="width:80%;">
                      {{ patient.patientName }}
                      <span
                        :class="['tag',
                            {'is-success':patient.status == inspectionStatuses.completed.code},
                            {'is-danger':patient.status == inspectionStatuses.noAppointment.code},
                            {'is-warning':patient.status == inspectionStatuses.appointment.code},
                            {'is-warning':patient.status == inspectionStatuses.underInspection.code},
                            {'is-warning':patient.status == inspectionStatuses.newCreate.code},
                            {'is-dark':patient.status == inspectionStatuses.cancel.code}
                            ]"
                        style="float:right"
                      >{{ patient.status | inspectionStatusFillter }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th style="width:20%;">点検実施住所：</th>
                    <td style="width:80%;">
                      {{ props.row.inspectionAddress }}
                      <b-field class="file" style="float:right">
                        <b-button
                          class="button is-primary has-text-centered"
                          icon-left="google-maps"
                          native-type="button"
                          v-on:click="doShowGoogleMap([
                                {
                                    'address': props.row.inspectionAddress,
                                    'name': patient.patientName
                                }
                                ])"
                        ></b-button>
                      </b-field>
                    </td>
                  </tr>
                  <tr>
                    <th>連絡先：</th>
                    <td colspan="2">{{ patient.patientPhone }}</td>
                  </tr>
                  <tr>
                    <th>点検担当者：</th>
                    <td colspan="2">{{ patient.staffName }}</td>
                  </tr>
                  <tr>
                    <th>点検対象機種：</th>
                    <td>
                      <table style="padding: 0px;">
                        <template v-for="product in patient.products">
                          <tr v-bind:key="product.productCode" v-if="product.inspectionKind===true">
                            <td style="width:250px;padding: 0px;">{{ product.productName }}({{ product.serial }})</td>
                            <td style="width:300px;padding: 0px;">(器械交換：{{ product.machineReplace }} , 点検指示内容：{{ product.inspectionOrder | inspectionOrderFilter }} )</td>
                            <td style="padding: 0px;"></td>
                          </tr>
                        </template>
                      </table>
                    </td>
                    <td>
                      <b-button
                        v-if="patient.status < inspectionStatuses.cancel.code"
                        :disabled="editFlg"
                        style="float:right; bottom:0;"
                        class="button is-primary has-text-centered"
                        icon-left="checkbox-multiple-marked-outline"
                        native-type="button"
                        v-on:click="startInspection(patient.reservationId,props.row.staffCode,props.row.staffName,patient.patientName,patient.patientCode,props.row.crossBorderCofficeSrc,props.row.crossBorderCofficeSrcCode, props.row.inspectionType, patient.status, patient, true)"
                      >点検開始</b-button>
                    </td>
                  </tr>
                </table>
              </div>
            </template>
          </b-table>
          <b-modal :active.sync="isShowGoogleMap" has-modal-card>
            <googleMap-form v-bind:marker="addressList"></googleMap-form>
          </b-modal>
        </div>
      </div>
    </section>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import MapTemplate from "./AppMapView";
import SignTemplate from "./common/Sign"
import * as inspection from "../utils/inspection"

var data = [];
const MapForm = {
  props: ["marker"],
  components: {
    maps: MapTemplate
  },
  template: `
      <maps :markers="marker" />
    `
};
export default {
  name: "AppAppointmentSearchResult",
  props: ["searchConditions"],
  methods: {
    search: function(searchConditions) {
      this.checkedRows = [];
      this.hasResult = true;
      this.searchConditions = searchConditions;
      var excuteApi = this.getAppointmentListPOST;
      var successCallBack = this.getAppointmentListSuccess;
      var errorCallBack = this.getAppointmentListError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAppointmentListPOST: function(client) {
      return client.apis.apiAppointment.getAppointmentListPOST({
        body: {
          officeCode: this.searchConditions.officeCode,
          startDate: this.searchConditions.startDate,
          endDate: this.searchConditions.endDate,
          staffCode: this.searchConditions.staffCode,
          staffName: this.searchConditions.staffName,
          status: this.searchConditions.appointmentStatusGroup,
          address: this.searchConditions.address,
          appointmentCode: this.searchConditions.appointmentCode
        }
      });
    },
    getAppointmentListSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
      for (var val in this.searchConditions.appointmentStatusGroup) {
        this.searchConditions.appointmentStatusGroup[val] =
          this.searchConditions.appointmentStatusGroup[val] + "";
      }
    },
    getAppointmentListError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    edit: function(reservationId, status, crossBorderCofficeTarCode, editFlg, row) {
      var isCrossBorder = false;
      if (
        crossBorderCofficeTarCode &&
        crossBorderCofficeTarCode !=
          JSON.parse(sessionStorage.getItem("userInfo")).officeCode
      ) {
        isCrossBorder = true;
      }
      this.$router.push({
        name: "AppAppointmentEdit",
        params: {
          appointmentCode: reservationId,
          status: status,
          searchConditions: this.searchConditions,
          isCrossBorder: isCrossBorder,
          editFlg: editFlg,
          isDealer: row.inspectionType == inspection.INSPECTION_TYPE_MAP.homeDealer.code,
        }
      });
    },
    startInspection: function(
      appointmentCode,
      staffCode,
      staffName,
      patientName,
      patientCode,
      officeName,
      officeCode,
      inspectionType,
      status,
      row,
      isBulk
    ) {
      if(this.healthCheckFlg==0){
        this.showErrorMessage("健康状態に問題があるため、点検はできません。");
        return
      }

      let locationRequired;
      switch (row.inspectionType) {
        case inspection.INSPECTION_TYPE_MAP.hospitalMyCompany.code:
          locationRequired = row.hospitalLocationRequired;
          break;

        case inspection.INSPECTION_TYPE_MAP.homeMyCompany.code:
          locationRequired = row.customerLocationRequired;
          break;

        default:
          break;
      }

      this.$router.push({
        name: "AppInspectionExecute",
        params: {
          appointmentCode: appointmentCode,
          staffCode: staffCode,
          staffName: staffName,
          patientName: patientName,
          patientCode: patientCode,
          officeName: officeName,
          officeCode: officeCode,
          searchConditions: this.searchConditions,
          isBulk: isBulk,
          isDealer: inspectionType == inspection.INSPECTION_TYPE_MAP.homeDealer.code,
          status: status,
          locationRequired: locationRequired,
        }
      });
    },
    doShowGoogleMapChecked: function() {
      const address = [];
      for (const selected of this.checkedRows) {
        if (!selected.patients.length) {
          const target = {
            address: selected.patientAddress,
            name: selected.patientName,
            patientZipCode: selected.patientZipCode,
          };
          address.push(target);
        } else {
          for (const patient of selected.patients) {
            const target = {
              address: patient.patientAddress,
              name: patient.patientName,
              patientZipCode: patient.patientZipCode,
            };
            address.push(target);
          }
        }
      }
      this.doShowGoogleMap(address);
    },
    doShowGoogleMap: function(address) {
      this.addressList = address;
      this.isShowGoogleMap = true;
    },

    inputSign: function() {
      scrollTo(0, 0);
      this.isSign = true;
      return;
    },

    completeBulkInspaction: async function(signInfo, row) {
      signInfo.row = row;
      this.signInfo = signInfo;

      if (navigator.geolocation) {
        try {
          // Promiseで結果を待ち受ける
          await this.getEndPosition();
        } catch (err) {
          console.log(err);

          // 取得拒否：警告あり、点検不可
          if (err == this.PERMISSION_DENIED) {
            this.showErrorMessage(
              "位置情報の取得に失敗しました。<br>設定を確認して、再度実行してください。"
            );
            return;
          }
          // 以下、取得拒否以外のエラー処理
          for (const patient of row.patients) {
            let locationRequired;
            switch (patient.products[0].inspectionType) {
              case inspection.INSPECTION_TYPE_MAP.hospitalMyCompany.code:
                locationRequired = patient.hospitalLocationRequired;
                break;

              case inspection.INSPECTION_TYPE_MAP.homeMyCompany.code:
                locationRequired = patient.customerLocationRequired;
                break;

              default:
                break;
            }

            // 情報必須：警告あり、点検継続
            if (locationRequired) {
              this.showErrorMessage("位置情報の取得に失敗しました。");
              break;
            }
          }
        }
      }

      // WebAPI Call
      return this.apiCall(this.setInspectionSignature, this.setInspectionSignatureSuccess, this.showErrorMessage);
    },

    setInspectionSignature: async function(client) {
      const res = await client.apis.apiInspection.setInspectionSignaturePOST({
        body: {
          reservationId: this.signInfo.row.reservationId,
          signature: this.signInfo.signData,
          alternativeWriting: this.signInfo.signFlg,
          alternativeWritingReason: this.signInfo.signReason,
          endLatitude: this.signInfo.endLatitude,
          endLongitude: this.signInfo.endLongitude
        }
      });
      this.signInfo = null;
      return res;
    },

    setInspectionSignatureSuccess: async function(res) {
      this.showSuccess(res);
      this.$emit("search");
      return;
    },

    getEndPosition() {
      return new Promise((resolve, reject) => {
        // 現在地を取得
        navigator.geolocation.getCurrentPosition(
          // 取得成功した場合
          position => {
            this.signInfo.endLatitude = position.coords.latitude;
            this.signInfo.endLongitude = position.coords.longitude;
            resolve(true);
          },
          // 取得失敗した場合
          error => {
            reject(error.code);
          },
          // オプション
          {
            timeout: this.timeOut
          }
        );
      });
    },

    disabledCompleteBulkInspaction(appointment) {
      let res = true;
      if (appointment.status == this.inspectionStatuses.underInspection.code) {
        let cancelNum = 0;
        let completedNum = 0;    
        for (const patent of appointment.patients) {
          switch (patent.status) {
            case this.inspectionStatuses.cancel.code:
              ++cancelNum;
              break;
            case this.inspectionStatuses.completed.code:
              ++completedNum;
              break;
          }
        }

        if (cancelNum + completedNum == appointment.patients.length) {
          res = false;
        }
      }

      return res;
    },
  },
  data() {
    var role = JSON.parse(sessionStorage.getItem("userInfo")).roleId;
    var healthCheckFlg = JSON.parse(sessionStorage.getItem("userInfo")).healthCheckFlg;
    var editFlg = false;
    if (role == 2) {
      editFlg = true;
    }
    const PERMISSION_DENIED = 1; // 位置情報取得拒否
    return {
      data,
      hasResult: true,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      defaultOpenedDetails: [1],
      currentPage: 1,
      perPage: 10,
      checkedRows: [],
      isShowGoogleMap: false,
      addressList: [],
      editFlg,
      healthCheckFlg,
      isSign: false,
      signInfo: null,
      inspectionStatuses: inspection.INSPECTION_STATUS_MAP,
      // 緯度・経度の取得タイムアウト(60秒)
      timeOut: 60000,
      PERMISSION_DENIED,
    };
  },
  filters: {},
  components: {
    "googleMap-form": MapForm,
    "sign-modal": SignTemplate,
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppAppointmentSearchResult.vue